const isTrue = value => {
  return value !== true ? `Please check this to proceed` : undefined;
}

export default isTrue;